import { Component, h, Host, Listen, Element } from '@stencil/core';
import { BreakpointWidths } from '../_helpers/breakpoints';

@Component({
	tag: 'ds-content-block-item',
})
export class ContentBlockItem {
	@Element()
	el: HTMLDsContentBlockItemElement;
	contentBlock?: HTMLDivElement;
	sidebarColumn?: HTMLDivElement;

	componentDidLoad() {
		this.contentBlock = this.el.querySelector('[data-content]');
		this.sidebarColumn = this.el.querySelector('[data-sidebar-column]');
		this.handleTitlePosition();
		this.handleGapBetweenItems();
	}

	handleTitlePosition = () => {
		if (this.contentBlock && this.sidebarColumn) {
			const isInContentBlock = this.contentBlock.querySelector('h2');
			const isInSidebarColumn = this.sidebarColumn.querySelector('h2');
			const prependContentTitleToElement = (prependTo) => {
				const title = this.el.querySelector('[data-title]');
				if (title) {
					const clonedTitle = title.cloneNode(true);
					const content = this.el.querySelector(prependTo);

					content.prepend(clonedTitle);
					title.remove();
				}
			};

			if (window.innerWidth < BreakpointWidths.MD && !isInContentBlock) {
				prependContentTitleToElement('[data-content]');
			}
			if (window.innerWidth === BreakpointWidths.MD) {
				prependContentTitleToElement('[data-sidebar-column]');
			}
			if (window.innerWidth > BreakpointWidths.MD && !isInSidebarColumn) {
				prependContentTitleToElement('[data-sidebar-column]');
			}
		}
	};

	// if content block item's heading is bigger than content, position it absolute to allow next item to come closer to its content if next item doesn't have heading
	handleGapBetweenItems = () => {
		const thisElH2 = this.el.querySelector('h2');
		if (this.sidebarColumn && window.innerWidth >= BreakpointWidths.MD) {
			const nextBlockItem = this.el
				.closest('article')
				.nextElementSibling?.querySelector('[data-sidebar-column]');
			const nextBlockItemH2 = nextBlockItem?.querySelector('h2');
			const children: HTMLCollection = this.contentBlock.children;
			let contentItemsHeight = 0;
			for (let i = 0; i < children.length; i++) {
				contentItemsHeight += children[i].getBoundingClientRect().height;
			}
			if (thisElH2 && thisElH2.offsetHeight > contentItemsHeight) {
				if (!nextBlockItemH2) {
					thisElH2.classList.add('ds-positioned-absolute');
				} else {
					thisElH2.classList.remove('ds-positioned-absolute');
				}
			} else if (thisElH2) {
				thisElH2.classList.remove('ds-positioned-absolute');
			}
		} else if (thisElH2) {
			thisElH2.classList.remove('ds-positioned-absolute');
		}
	};

	// Used to move heading from one column to another
	@Listen('resize', { target: 'window', passive: true })
	onResize() {
		this.handleTitlePosition();
		this.handleGapBetweenItems();
	}

	render() {
		return (
			<Host>
				<slot />
			</Host>
		);
	}
}
